//@flow
import React from 'react';
import IconClose from '../../Icon/components/IconClose.react';
import _ from 'underscore';
import HeapActions from '../../Actions/heap';

type Props = {
  className:string,
  closeNotification:() => void,
  children?:React$Node,
  data:Object,
  name:string,
  timeout:?number,
};

function _getClassName(props:Props):string {
  const defaultClass = 'notification';
  return props.className ? `${defaultClass} ${props.className}` : defaultClass;
}

function _renderIconClose(props:Props):?React$Node {
  if (props.closeNotification) return <IconClose closeAction={props.closeNotification} />;
}

export default class BaseNotification extends React.Component<Props> {
  timeoutId:?TimeoutID;

  componentDidMount() {
    const heapData = Object.assign({ name: this.props.name }, this.props.data || {});
    HeapActions.trackNotification(heapData);
    this._startTimeout();
  }

  componentDidUpdate(prevProps:Props) {
    // if there is a notification and it's changed, then start the timer
    if (this.props.data && !_.isEqual(this.props.data, prevProps.data)) {
      this._startTimeout();
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }

  _startTimeout() {
    if (!this.props.timeout) return;

    // clear the existing timeout since we're going to start a new one
    if (this.timeoutId) clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.timeoutId = null;
      this.props.closeNotification();
    }, this.props.timeout);
  }

  render() {
    return (
      <div className={_getClassName(this.props)} role="alert">
        {_renderIconClose(this.props)}
        {this.props.children}
      </div>
    );
  }
}
